import api from "../config/axios";

// Get current user profile
export const getCurrentUserProfile = async () => {
  try {
    const response = await api.get("/admin/profile");
    return response.data;
  } catch (error) {
    console.error("Error fetching user profile:", error);
    throw error;
  }
};

// Update user profile
export const updateUserProfile = async (profileData) => {
  try {
    const response = await api.put("/admin/profile", profileData);
    return response.data;
  } catch (error) {
    console.error("Error updating profile:", error);
    throw error;
  }
};

// Change password
export const changePassword = async (passwordData) => {
  try {
    const response = await api.post("/admin/settings/change-password", passwordData);
    return response.data;
  } catch (error) {
    console.error("Error changing password:", error);
    throw error;
  }
};

// Upload profile image
export const uploadProfileImage = async (imageFile) => {
  try {
    const formData = new FormData();
    formData.append("image", imageFile);
    
    const response = await api.post("/admin/upload-profile-image", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error uploading profile image:", error);
    throw error;
  }
};

// Update notification settings
export const updateNotificationSettings = async (settings) => {
  try {
    const response = await api.put("/admin/settings/notifications", settings);
    return response.data;
  } catch (error) {
    console.error("Error updating notification settings:", error);
    throw error;
  }
};

// Get notification settings
export const getNotificationSettings = async () => {
  try {
    const response = await api.get("/admin/settings/notifications");
    return response.data;
  } catch (error) {
    console.error("Error fetching notification settings:", error);
    throw error;
  }
};

// Update security settings
export const updateSecuritySettings = async (settings) => {
  try {
    const response = await api.put("/admin/settings/security", settings);
    return response.data;
  } catch (error) {
    console.error("Error updating security settings:", error);
    throw error;
  }
};

// Get security settings
export const getSecuritySettings = async () => {
  try {
    const response = await api.get("/admin/settings/security");
    return response.data;
  } catch (error) {
    console.error("Error fetching security settings:", error);
    throw error;
  }
};

// Pricing settings (VAT, service charge, other fees)
export const getPricingSettings = async () => {
  try {
    const response = await api.get("/admin/settings/pricing");
    return response.data;
  } catch (error) {
    console.error("Error fetching pricing settings:", error);
    throw error;
  }
};

export const updatePricingSettings = async (settings) => {
  try {
    const response = await api.put("/admin/settings/pricing", settings);
    return response.data;
  } catch (error) {
    console.error("Error updating pricing settings:", error);
    throw error;
  }
};

// Delete account
export const deleteAccount = async (confirmationData) => {
  try {
    const response = await api.delete("/admin/settings/delete-account", {
      data: confirmationData,
    });
    return response.data;
  } catch (error) {
    console.error("Error deleting account:", error);
    throw error;
  }
};

// Export user data
export const exportUserData = async () => {
  try {
    const response = await api.get("/admin/settings/export-data", {
      responseType: "blob",
    });
    return response.data;
  } catch (error) {
    console.error("Error exporting user data:", error);
    throw error;
  }
}; 